export default function VideoSection() {
  return (
    <section id="video" className="bg-[#060a14] py-14 md:py-28">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-[#4a7fa5] font-bold uppercase tracking-widest text-xs md:text-sm mb-3">
            See It In Action
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight max-w-3xl mx-auto">
            Watch How We Seal Concrete{" "}
            <span className="text-[#4a7fa5]">From the Inside Out</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base mt-3 md:mt-4 max-w-xl mx-auto leading-relaxed">
            No demolition. No disruption. See exactly how the CLWizard process works — from micro-drill to permanent seal.
          </p>
        </div>

        {/* Video container — portrait 9:16, centered */}
        <div className="flex justify-center">
          <div className="relative rounded-xl overflow-hidden border border-[#1a3a5c]/40 bg-black w-full max-w-xs sm:max-w-sm md:max-w-md">
            {/* Decorative top bar */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#1a3a5c] via-[#4a7fa5] to-[#1a3a5c] z-10"></div>

            <video
              className="w-full"
              style={{ aspectRatio: "9/16", display: "block" }}
              controls
              playsInline
              preload="metadata"
              poster="https://public.readdy.ai/ai/img_res/edited_fa62fa0ff7629e8d60d93a80dd405a6c_e96c55da.jpg"
            >
              <source
                src="https://storage.readdy-site.link/project_files/de14de91-8398-42e0-b55a-e05efa7ecc5f/42f5c998-24dd-41d5-9ff4-1f888cefc683_1.mp4?v=b83c95c718148462368c30ddbc965879"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Trust strip below video */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 md:gap-6 mt-8 md:mt-10">
          {[
            { icon: "ri-time-line", text: "Process completed in hours, not weeks" },
            { icon: "ri-building-line", text: "Building stays fully operational" },
            { icon: "ri-shield-check-line", text: "Backed by 5-year written warranty" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-gray-400 text-sm justify-center sm:justify-start">
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-[#4a7fa5]`}></i>
              </span>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
